<template>
	<nk-wrapper
		v-if="context && context.latitude && context.longitude"
		spacing="md"
		class="h-80 max-h-screen w-full"
	>
		<client-only
			v-if="
				(context.latitude && context.longitude) || context.flurstuecke.length
			"
		>
			<LMap
				ref="map"
				:use-global-leaflet="false"
				:center="[parseFloat(context.latitude), parseFloat(context.longitude)]"
				:zoom="18"
				@ready="init"
			>
				<l-tile-layer
					url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					layer-type="base"
					name="OpenStreetMap"
				/>

				<!-- Marker, Flurstücke -->
				<template v-if="context.flurstuecke.length">
					<l-marker
						v-for="(flurstueck, indexFlurstuecke) in context.flurstuecke"
						:key="`gmflist${indexFlurstuecke}`"
						:lat-lng="[
							parseFloat(flurstueck.adresse.geokoordinaten.latitude),
							parseFloat(flurstueck.adresse.geokoordinaten.longitude),
						]"
					>
						<l-popup>
							<strong>
								{{ flurstueck.titel }}
							</strong>
							<br />
							{{ flurstueck.adresse.strasse }}
							<br />
							{{ flurstueck.adresse.plz }} {{ flurstueck.adresse.ort }}
							<br />
						</l-popup>
					</l-marker>
				</template>

				<!-- Marker, Baugebiet -->
				<l-marker
					v-else
					:lat-lng="[
						parseFloat(context.latitude),
						parseFloat(context.longitude),
					]"
				/>
			</LMap>
		</client-only>
	</nk-wrapper>
</template>

<script>
import {ref} from 'vue';
import 'leaflet/dist/leaflet.css';
import {LMap, LTileLayer, LPopup, LMarker} from '@vue-leaflet/vue-leaflet';
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateBaugebieteKarte',

	components: {
		LMap,
		LTileLayer,
		LPopup,
		LMarker,
	},

	mixins: [TemplatesDefault],

	setup(ctx) {
		const map = ref(null);

		const init = () => {
			if (map.value && ctx.context.flurstuecke.length) {
				map.value.leafletObject.fitBounds(
					ctx.context.flurstuecke.map(flurstueck => {
						return [
							parseFloat(flurstueck.adresse.geokoordinaten.latitude),
							parseFloat(flurstueck.adresse.geokoordinaten.longitude),
						];
					}),
				);
			}
		};
		return {
			map,
			init,
		};
	},
};
</script>
